import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import NotesSectionTable from './CustomMovementsSectionTable';
import { useCustomMovementsSection } from '../context/CustomMovementsSectionContext';

const CustomMovementsSectionBody: FC = () => {
  const { data, actions } = useCustomMovementsSection();

  const showPagination =
    data.customMovements &&
    data.customMovementsTotal > (data.rowsPerPage || 10);

  return (
    <div className="mt-4">
      {data.isLoadingCustomMovements ? (
        <TableSkeleton
          rows={10}
          columns={4}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <NotesSectionTable />
      )}

      {showPagination && (
        <DataTablePagination
          className="border-0"
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.customMovementsTotal || 0}
          paginate={actions.handleChangePage}
          currentPage={data.page}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};
export default CustomMovementsSectionBody;
